export default "__VITE_ASSET__b8f25cbc__"